<div class="privacy-section">
    <div class="container">
        <div class="legal-content">
            <h1>{{ 'GDPR.TITLE' | translate }}</h1>
            <div class="last-updated">
                {{ 'GDPR.LAST_UPDATED' | translate }}: {{ '2024-03-20' | date:'longDate' }}
            </div>

            <section>
                <h2>{{ 'GDPR.INTRODUCTION.TITLE' | translate }}</h2>
                <p>{{ 'GDPR.INTRODUCTION.CONTENT' | translate }}</p>
            </section>

            <section>
                <h2>{{ 'GDPR.RIGHTS.TITLE' | translate }}</h2>
                <p>{{ 'GDPR.RIGHTS.DESCRIPTION' | translate }}</p>
                <ul>
                    <li>
                        <strong>{{ 'GDPR.RIGHTS.ACCESS.TITLE' | translate }}</strong>
                        <p>{{ 'GDPR.RIGHTS.ACCESS.DESCRIPTION' | translate }}</p>
                    </li>
                    <li>
                        <strong>{{ 'GDPR.RIGHTS.RECTIFICATION.TITLE' | translate }}</strong>
                        <p>{{ 'GDPR.RIGHTS.RECTIFICATION.DESCRIPTION' | translate }}</p>
                    </li>
                    <li>
                        <strong>{{ 'GDPR.RIGHTS.ERASURE.TITLE' | translate }}</strong>
                        <p>{{ 'GDPR.RIGHTS.ERASURE.DESCRIPTION' | translate }}</p>
                    </li>
                    <li>
                        <strong>{{ 'GDPR.RIGHTS.RESTRICTION.TITLE' | translate }}</strong>
                        <p>{{ 'GDPR.RIGHTS.RESTRICTION.DESCRIPTION' | translate }}</p>
                    </li>
                    <li>
                        <strong>{{ 'GDPR.RIGHTS.PORTABILITY.TITLE' | translate }}</strong>
                        <p>{{ 'GDPR.RIGHTS.PORTABILITY.DESCRIPTION' | translate }}</p>
                    </li>
                    <li>
                        <strong>{{ 'GDPR.RIGHTS.OBJECT.TITLE' | translate }}</strong>
                        <p>{{ 'GDPR.RIGHTS.OBJECT.DESCRIPTION' | translate }}</p>
                    </li>
                </ul>
            </section>

            <section>
                <h2>{{ 'GDPR.DATA_COLLECTION.TITLE' | translate }}</h2>
                <p>{{ 'GDPR.DATA_COLLECTION.DESCRIPTION' | translate }}</p>
                <ul>
                    <li>{{ 'GDPR.DATA_COLLECTION.PERSONAL_INFO' | translate }}</li>
                    <li>{{ 'GDPR.DATA_COLLECTION.USAGE_DATA' | translate }}</li>
                    <li>{{ 'GDPR.DATA_COLLECTION.COOKIES' | translate }}</li>
                </ul>
            </section>

            <section>
                <h2>{{ 'GDPR.DATA_PROCESSING.TITLE' | translate }}</h2>
                <p>{{ 'GDPR.DATA_PROCESSING.DESCRIPTION' | translate }}</p>
                <ul>
                    <li>{{ 'GDPR.DATA_PROCESSING.PURPOSE' | translate }}</li>
                    <li>{{ 'GDPR.DATA_PROCESSING.LEGAL_BASIS' | translate }}</li>
                    <li>{{ 'GDPR.DATA_PROCESSING.RETENTION' | translate }}</li>
                </ul>
            </section>

            <section>
                <h2>{{ 'GDPR.DATA_PROTECTION.TITLE' | translate }}</h2>
                <p>{{ 'GDPR.DATA_PROTECTION.DESCRIPTION' | translate }}</p>
                <ul>
                    <li>{{ 'GDPR.DATA_PROTECTION.SECURITY_MEASURES' | translate }}</li>
                    <li>{{ 'GDPR.DATA_PROTECTION.THIRD_PARTIES' | translate }}</li>
                    <li>{{ 'GDPR.DATA_PROTECTION.INTERNATIONAL_TRANSFERS' | translate }}</li>
                </ul>
            </section>

            <section>
                <h2>{{ 'TERMS.CONTACT.TITLE' | translate }}</h2>
                <p>{{ 'TERMS.CONTACT.DESCRIPTION' | translate }}</p>
                <div class="contact-info">
                    <p><strong>{{ 'CONTACT.DATA.EMAIL_CONTACT.LABEL' | translate }}:</strong> {{ 'CONTACT.DATA.EMAIL_DPO.VALUE' | translate: translationParams }}</p>
                    <p><strong>{{ 'CONTACT.DATA.PHONE.LABEL' | translate }}:</strong> {{ 'CONTACT.DATA.PHONE.VALUE' | translate: translationParams }}</p>
                </div>
            </section>
           
        </div>
    </div>
</div> 